import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon, Menu as MenuIcons, RestoreIcon } from 'assets/icons';
import { UserService, PlanService } from 'services';
import moment from 'moment';
import ModalUpdateUser from './modal-update-user';
import ModalCreateUser from './modal-create-user';
import ModalSelectPlan from './select-plan';
import ModalSelectDocumentPlan from './select-document-plan';
import ModalSelectBillPlan from './select-bill-plan';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	plan_id: '',
	document_plan_id: '',
	bill_plan_id: ''
}

const PLAN_MODALS = {
    identity: {
    	component: ModalSelectPlan,
    	title: 'Planes de KYC'
    },
    document: {
    	component: ModalSelectDocumentPlan,
    	title: 'Planes de Documentos'
    },
    bill: {
    	component: ModalSelectBillPlan,
    	title: 'Planes de Facturas'
    },
};

class Users extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Nombre',
			'Email',
			'Teléfono',
			'Planes',
			''
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null,
		user_id: null,
		plans: [],
		bill_plans: [],
		document_plans: [],
		visible_create: false,
		visible_modal: {
			visible: false,
			type: null
		}
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Usuarios',
				onBack: null,
				subtitle: 'Consulta y administra todos los usuarios registrados en el sistema.',
				color: '#edf0fe',
				icon: MenuIcons.Menu3
			}
		});

		this.loadPlans();
		this.load();
	}

	loadPlans = async () => {
		const res: any = await UserService.admin.getPlanList({
			withoutLoading: true
		});
		this.setState({
			plans: res.plans || [],
			document_plans: res.document_plans || [],
			bill_plans: res.bill_plans || [],
		});
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await UserService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.users.rows,
			last_page: res.users.count
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el usuario?',async () => {
			await UserService.admin.delete({
				user_id: item?.id
			});	
			Globals.showSuccess("Se ha eliminado el usuario correctamente");
			this.load(true);
		});
	}

	changePlan = (user_id: number, type: string) => {
		this.setState({
			user_id,
			visible_modal: {
				visible: true,
				type
			}
		});
	}

	onClosePlan = () => {
		this.setState({
			user_id: null,
			visible_modal: {
				visible: false,
				type: null
			}
		},() => this.load(true));
	}
	
	add = () => {
		this.setState({
			visible_create: true
		});
	}

	onCloseCreate = () => {
		this.setState({
			visible_create: false
		},() => this.load(true));
	}

	render() {
		const { visible, visible_create, visible_modal } = this.state;
		// @ts-ignore
		const SelectedModalContent = PLAN_MODALS[visible_modal?.type]?.component;
		// @ts-ignore
		const title = PLAN_MODALS[visible_modal?.type]?.title;

		return (
			<div id="admin-users">
				<Modal
		          className="modal-update-user"
		          visible={ visible }
		          title="Editar Usuario"
		          onClose={ () => this.onClose() }
		        >
		          <ModalUpdateUser
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-update-user"
		          visible={ visible_create }
		          title="Crear Usuario"
		          onClose={ () => this.onCloseCreate() }
		        >
		          <ModalCreateUser
		            onClose={ () => this.onCloseCreate() } />
		      	</Modal>

		      	<Modal
		          className="modal-view-plans"
		          visible={ visible_modal?.visible }
		          title={ title }
		          onClose={ () => this.onClosePlan() }
		        >
		        	{
		        		SelectedModalContent != null && (
		        			<SelectedModalContent
		        				user_id={ this.state.user_id }
		            			onClose={ () => this.onClosePlan() }
		        			/>
		        		)
		        	}
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md">
								<Input
									value={ this.state.form.search }
									name="search"
									placeholder="Buscar"
									label="Buscar por nombre o correo"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md">
								<Select
									color="white"
									placeholder="Seleccionar"
									label="Plan de KYC"
									name="plan_id"
									onChange={ (e: any) => this.change(e,() => this.load(true)) }
									value={ this.state.form.plan_id }
									options={ this.state.plans.map((item: any) => {
										return {
											value: item.id,
											label: item.name
										}
									}) } />
							</div>
							<div className="col-md">
								<Select
									color="white"
									placeholder="Seleccionar"
									label="Plan de Documentos"
									name="document_plan_id"
									onChange={ (e: any) => this.change(e,() => this.load(true)) }
									value={ this.state.form.document_plan_id }
									options={ this.state.document_plans.map((item: any) => {
										return {
											value: item.id,
											label: item.name
										}
									}) } />
							</div>
							<div className="col-md">
								<Select
									color="white"
									placeholder="Seleccionar"
									label="Plan de Facturas"
									name="bill_plan_id"
									onChange={ (e: any) => this.change(e,() => this.load(true)) }
									value={ this.state.form.bill_plan_id }
									options={ this.state.bill_plans.map((item: any) => {
										return {
											value: item.id,
											label: item.name
										}
									}) } />
							</div>
						</div>
						<div className="row">
							<div className="col-md-12 text-right">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ RestoreIcon } />
											<p>Limpiar</p>
										</button>
									)
								}
								{
									checkPermission(Constants.MODULES.USERS,'write') && (
										<button className="btn add-btn" onClick={ this.add }>
											<img src={ AddIcon } />
											<p>Nuevo</p>
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table title="Usuarios registrados" data={ this.state.data.length } header={ this.state.header }
					pagination={
						<Pagination 
							pages={ this.state.last_page } 
							active={ this.state.page }
							onChange={ async (page: number) => {
								await this.setState({
									page: page
								});
								this.load();
							} } />
					}
				>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i?.name + ' ' + i?.lastname }</td>
								<td>{ i.email }</td>
								<td>{ i.phone }</td>
								<td>
									<div className={ `item-plan ${ i?.remaining_verifications > 0 ? 'active' : '' }` } onClick={ () => {
										if (checkPermission(Constants.MODULES.USERS,'write')) {
											this.changePlan(i.id,'identity');
										}
									} }>
										<p><span className="bold">KYC:</span> { i?.plan_user_admin?.plan?.name || 'Sin plan' }</p>
										<p>Cantidad: { i?.remaining_verifications }</p>
									</div>
									<div className={ `item-plan ${ i?.remaining_document_verifications > 0 ? 'active' : '' }` } onClick={ () => {
										if (checkPermission(Constants.MODULES.USERS,'write')) {
											this.changePlan(i.id,'document');
										}
									} }>
										<p><span className="bold">Documentos:</span> { i?.document_plan_user_admin?.plan?.name || 'Sin plan' }</p>
										<p>Cantidad: { i?.remaining_document_verifications }</p>
									</div>
									<div className={ `item-plan ${ i?.remaining_bill_verifications > 0 ? 'active' : '' }` } onClick={ () => {
										if (checkPermission(Constants.MODULES.USERS,'write')) {
											this.changePlan(i.id,'bill');
										}
									} }>
										<p><span className="bold">Facturas:</span> { i?.bill_plan_user_admin?.plan?.name || 'Sin plan' }</p>
										<p>Cantidad: { i?.remaining_bill_verifications }</p>
									</div>
								</td>
								<td style={{ 'whiteSpace': 'nowrap' }}>
									{
										checkPermission(Constants.MODULES.USERS,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.USERS,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Users);